import { missingFuncArgs } from './funcArgSanitizer';

/**
 * FIN-13260 — incomplete-leaf detection, extracted from QueryBuilder so it can be tested.
 *
 * A stored `is_in_lookup_list` leaf persisted with `valueSrc:["field"]` (the AFC-2087 shape)
 * makes RAQB resolve the value as a FIELD id. No such field exists, so `Utils.checkTree` returns
 * the leaf as `value:[null], valueSrc:["value"]` with a valueError — i.e. incomplete. That raised
 * disableAction, which used to lock every sub-tab in the drawer, so the analyst could not even
 * navigate to the rule they needed to fix. The canonical shape is
 * `value:[["<list name>"]], valueSrc:["value"]`.
 */
/**
 * FIN-13190 — `config` is optional. When it is supplied, a rule is also incomplete when a
 * function on its LEFT-hand side has an operand slot the analyst has not filled in. The checks
 * below only look at the right-hand side, so such a rule used to reach the backend and come back
 * 422; now that the sanitiser drops the empty argument, it would instead save as a silently
 * one-operand sum. Blocking it here names the offending rule in the drawer footer.
 */
export const isRuleIncomplete = (rule, config) =>
  !rule.field ||
  !rule.operator ||
  rule.value?.[0] === undefined ||
  rule.value?.[0] === null ||
  (rule.valueType?.[0] === 'number' &&
    rule.valueSrc?.[0] === 'value' &&
    !Number.isFinite(rule.value?.[0])) ||
  rule.value?.[0] === '' ||
  (!!config && missingFuncArgs(rule.field, config).length > 0);

/** Walks an RAQB tree (plain JS) and returns `{ path, rule }` for every incomplete leaf. */
export const findIncompleteRules = (node, config, path = []) => {
  let incomplete = [];

  if (node.type === 'group' || node.type === 'group_ext') {
    Object.entries(node.children1 || {}).forEach(([key, child]) => {
      incomplete = incomplete.concat(
        findIncompleteRules(child, config, [...path, key])
      );
    });
  } else if (
    node.type === 'rule' &&
    isRuleIncomplete(node.properties, config)
  ) {
    incomplete.push({ path, rule: node });
  }

  return incomplete;
};
